<template>
  <svg viewBox="0 0 1024 1024" fill="currentColor">
    <path
      d="M512 258.759111c176.696889 0 300.373333 103.651556 371.541333 253.212445H981.333333C906.154667 326.456889 724.48 167.025778 512 167.025778c-212.48 0-394.154667 159.431111-469.333333 344.945778h97.792C211.655111 362.382222 335.303111 258.759111 512 258.759111z m0 506.453333c-176.668444 0-300.344889-103.651556-371.512889-253.240888H42.666667c75.178667 185.571556 256.824889 345.002667 469.333333 345.002666s394.154667-159.402667 469.333333-345.002666h-97.792c-71.196444 149.617778-194.844444 253.240889-371.541333 253.240888z"
    />
    <path d="M512 512m-128 0a128 128 0 1 0 256 0 128 128 0 1 0-256 0Z" />
  </svg>
</template>
